import React, { useState } from 'react'
import './PasswordAuth.css'
import { login } from '../services/api'

interface PasswordAuthProps {
  onAuthenticated: () => void
}

const PasswordAuth: React.FC<PasswordAuthProps> = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')

    try {
      const response = await login(password)
      
      if (response.success) {
        // Store authentication state in localStorage
        localStorage.setItem('waterplan_authenticated', 'true')
        localStorage.setItem('waterplan_auth_timestamp', Date.now().toString())
        onAuthenticated()
      } else {
        setError('Incorrect password. Please try again.')
        setPassword('')
      }
    } catch (err) {
      setError('Authentication failed. Please try again.')
      setPassword('')
    }
    
    setIsLoading(false)
  }

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value)
    if (error) setError('') // Clear error when user starts typing
  }

  return (
    <div className="password-auth-container">
      <div className="password-auth-modal">
        <div className="password-auth-header">
          <img src="/waterplan_logo.jpeg" alt="Waterplan" className="auth-logo" />
          <h1>VWBA Evaluator Access</h1>
          <p>Please enter the password to access the system</p>
        </div>
        
        <form onSubmit={handleSubmit} className="password-auth-form">
          <div className="password-input-group">
            <input
              type="password"
              value={password}
              onChange={handlePasswordChange}
              placeholder="Enter password"
              className={`password-input ${error ? 'error' : ''}`}
              disabled={isLoading}
              autoFocus
            />
            {error && <div className="error-message">{error}</div>}
          </div>
          
          <button 
            type="submit" 
            className="password-submit-btn"
            disabled={isLoading || !password.trim()}
          >
            {isLoading ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
                <span>Verifying...</span>
              </div>
            ) : (
              'Access System'
            )}
          </button>
        </form>
        
        <div className="password-auth-footer">
          <p>Protected by Waterplan Security</p>
        </div>
      </div>
    </div>
  )
}

export default PasswordAuth
